import { jsxs, jsx } from "react/jsx-runtime";
import { Text, Spinner, Paragraph, Box } from "@zillow/constellation-10";
import { useState, useEffect } from "react";
import MortgagePageClassification from "../../utils/mortgagehelpers/MortgagePageClassification.esm.js";
import { PAGE_FLAVOR_LOAN_TYPE_MAP, LOAN_TYPES } from "../../utils/mortgagehelpers/constants.esm.js";
import { setServerUrl } from "../../utils/mortgagehelpers/mortgage-helpers.esm.js";
import LegalDisclosuresModal from "../LegalDisclosuresModal/LegalDisclosuresModal.esm.js";
import { getMortgageRates } from "../LegalDisclosuresModal/constants.esm.js";
import { fetchRatesArticle } from "./MortgageRatesSummary.utils.esm.js";
import { RatesArticle } from "./RateArticle.esm.js";
const MortgageRatesSummary = ({
  pathname
}) => {
  const classification = new MortgagePageClassification(pathname ? pathname : "/mortgage-rates/");
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [rates, setRates] = useState({});
  const [error, setError] = useState(false);
  useEffect(() => {
    setServerUrl();
  }, []);
  useEffect(() => {
    fetchRatesArticle({
      refinance: classification.refinance,
      stateAbbreviation: classification.stateAbbreviation,
      loanType: PAGE_FLAVOR_LOAN_TYPE_MAP[classification.flavor] ?? LOAN_TYPES.Conventional,
      program: "Fixed30Year"
    }).then((response) => {
      if (response.hasApiError) {
        setError(true);
        setLoading(false);
      } else {
        setArticle(response);
        setLoading(false);
      }
    });
  }, []);
  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await getMortgageRates(pathname);
        setRates(response);
      } catch (error2) {
        console.error("Error fetching mortgage rates:", error2);
      }
    };
    fetchRates();
  }, [pathname]);
  if (loading) {
    return /* @__PURE__ */ jsxs(Text, { textStyle: "body", css: {
      display: "inline-flex",
      alignItems: "center",
      gap: "tightest"
    }, children: [
      /* @__PURE__ */ jsx(Spinner, {}),
      "Loading..."
    ] });
  } else if (error) {
    return /* @__PURE__ */ jsx(Paragraph, { children: "An error occurred, please try again later." });
  } else {
    return /* @__PURE__ */ jsxs(Box, { children: [
      /* @__PURE__ */ jsx(RatesArticle, { article }),
      /* @__PURE__ */ jsx(Box, { css: {
        marginTop: "{spacing.400}"
      }, children: /* @__PURE__ */ jsx(LegalDisclosuresModal, { classification, rates }) })
    ] });
  }
};
export {
  MortgageRatesSummary as default
};
